import React from "react";

import ForgotPasswordFeature from "../features/auth/forgotPassword/ForgotPassword";

function ForgotPassword(props) {
  return <ForgotPasswordFeature {...props} />;
}

export default ForgotPassword;
